// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Lang_eval$BwaxMobile = require("../../lang_eval.bs.js");
var Lang_value_set$BwaxMobile = require("../../lang_value_set.bs.js");
var Runtime_common$BwaxMobile = require("../runtime_common.bs.js");

var module_name = "Set";

var src = "\nmodule " + (String(module_name) + ";\n\n-- Create an empty set.\nempty: () -> Set t = external;\n\n-- Create a set with one value.\nsingleton : comparable -> Set comparable = external;\n\n-- Insert a value into a set.\ninsert: comparable -> Set comparable -> Set comparable = external;\n\n-- Remove a value from a set. If the value is not found, no changes are made.\nremove : comparable -> Set comparable -> Set comparable = external;\n\n-- Remove a list of value from a set.\nremoveMany: List comparable -> Set comparable -> Set comparable = external;\n\n-- Determine if a set is empty.\nisEmpty : Set a -> Bool = external;\n\n-- Determine if a value is in a set.\nmember : comparable -> Set comparable -> Bool = external;\n\nhas = member;\n\n-- Determine the number of elements in a set.\nsize : Set a -> Int = external;\n\n\n-- Get the union of two sets. Keep all values.\nunion : Set comparable -> Set comparable -> Set comparable = external;\n\n-- Get the intersection of two sets. Keeps values that appear in both sets.\nintersect : Set comparable -> Set comparable -> Set comparable = external;\n\n-- Get the difference between the first set and the second. \n-- Keeps values that do not appear in the second set.\ndiff : Set comparable -> Set comparable -> Set comparable = external;\n\n\n\n-- Convert a set into a list, sorted from lowest to highest.\ntoList : Set a -> List a = external;\n\n-- Convert a list into a set, removing any duplicates.\nfromList : List comparable -> Set comparable = external;\n\n\n-- Fold over the values in a set, in order from lowest to highest.\nfoldl : (acc -> t -> acc) -> acc -> Set t -> a = external;\n\n-- Map a function onto a set, creating a new set with no duplicates.\nmap:  (comparable -> comparable2) -> Set comparable -> Set comparable2 = external;\n\n\n-- Only keep elements that pass the given test.\nfilter : (comparable -> Bool) -> Set comparable -> Set comparable = external;\n\n\n-- Create two new sets. \n-- The first contains all the elements that passed the given test, \n-- and the second contains all the elements that did not.\npartition :\n    (comparable -> Bool)\n    -> Set comparable\n    -> ( Set comparable, Set comparable ) = external;\n\n\n\n-- Check if some pair passes the given test\nany: (t ->  Bool) -> Set t -> Bool = external;\n\n-- Check if every pair passes the given test\nall: (t -> Bool) -> Set t -> Bool = external;\n\n\n-- Returns  the lowest key, or Nothing if not exists.\nminimum: Set t -> Maybe t = external;\n\n-- Return the highest key, or Nothing if not exists.\nmaximum: Set t -> Maybe t = external;\n\n-- Check if two sets are equal;\nisEqual: Set t -> Set t -> Bool = external;\n\n\n");

function invalid_args(name) {
  throw [
        Lang_eval$BwaxMobile.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

function pack_set(set) {
  return /* tuple */[
          /* V_tagged_raw */Block.__(8, [
              "Set",
              set
            ]),
          Runtime_common$BwaxMobile.nt
        ];
}

function pack_predicate(f) {
  return (function (k) {
      var result = Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
            k,
            /* [] */0
          ], Runtime_common$BwaxMobile.nt);
      var match = result[0];
      if (typeof match === "number" || match.tag !== /* V_literal */5) {
        return invalid_args("predicate");
      } else {
        var match$1 = match[0];
        if (typeof match$1 === "number" || match$1.tag !== /* Bool */4) {
          return invalid_args("predicate");
        } else {
          return match$1[0];
        }
      }
    });
}

var external_vals_000 = /* tuple */[
  "empty",
  Runtime_common$BwaxMobile.pack_func(1, (function (param) {
          return pack_set(Lang_value_set$BwaxMobile.empty(/* () */0));
        }))
];

var external_vals_001 = /* :: */[
  /* tuple */[
    "singleton",
    Runtime_common$BwaxMobile.pack_func(1, (function (param) {
            if (param && !param[1]) {
              return pack_set(Lang_value_set$BwaxMobile.singleton(param[0]));
            } else {
              return invalid_args("singleton");
            }
          }))
  ],
  /* :: */[
    /* tuple */[
      "insert",
      Runtime_common$BwaxMobile.pack_func(2, (function (param) {
              if (param) {
                var match = param[1];
                if (match) {
                  var match$1 = match[0][0];
                  if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                    return invalid_args("insert");
                  } else {
                    return pack_set(Lang_value_set$BwaxMobile.insert(param[0], match$1[1]));
                  }
                } else {
                  return invalid_args("insert");
                }
              } else {
                return invalid_args("insert");
              }
            }))
    ],
    /* :: */[
      /* tuple */[
        "remove",
        Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                if (param) {
                  var match = param[1];
                  if (match) {
                    var match$1 = match[0][0];
                    if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                      return invalid_args("remove");
                    } else {
                      return pack_set(Lang_value_set$BwaxMobile.remove(param[0], match$1[1]));
                    }
                  } else {
                    return invalid_args("remove");
                  }
                } else {
                  return invalid_args("remove");
                }
              }))
      ],
      /* :: */[
        /* tuple */[
          "removeMany",
          Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                  if (param) {
                    var match = param[0][0];
                    if (typeof match === "number" || match.tag !== /* V_list */1) {
                      return invalid_args("removeMany");
                    } else {
                      var match$1 = param[1];
                      if (match$1) {
                        var match$2 = match$1[0][0];
                        if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                          return invalid_args("removeMany");
                        } else {
                          return pack_set(Lang_value_set$BwaxMobile.remove_many(match[0], match$2[1]));
                        }
                      } else {
                        return invalid_args("removeMany");
                      }
                    }
                  } else {
                    return invalid_args("removeMany");
                  }
                }))
        ],
        /* :: */[
          /* tuple */[
            "isEmpty",
            Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                    if (param) {
                      var match = param[0][0];
                      if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                        return invalid_args("isEmpty");
                      } else {
                        return Runtime_common$BwaxMobile.pack_bool(Lang_value_set$BwaxMobile.is_empty(match[1]));
                      }
                    } else {
                      return invalid_args("isEmpty");
                    }
                  }))
          ],
          /* :: */[
            /* tuple */[
              "member",
              Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                      if (param) {
                        var match = param[1];
                        if (match) {
                          var match$1 = match[0][0];
                          if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                            return invalid_args("member");
                          } else {
                            return Runtime_common$BwaxMobile.pack_bool(Lang_value_set$BwaxMobile.member(param[0], match$1[1]));
                          }
                        } else {
                          return invalid_args("member");
                        }
                      } else {
                        return invalid_args("member");
                      }
                    }))
            ],
            /* :: */[
              /* tuple */[
                "size",
                Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                        if (param) {
                          var match = param[0][0];
                          if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                            return invalid_args("size");
                          } else {
                            return Runtime_common$BwaxMobile.pack_int(Lang_value_set$BwaxMobile.size(match[1]));
                          }
                        } else {
                          return invalid_args("size");
                        }
                      }))
              ],
              /* :: */[
                /* tuple */[
                  "union",
                  Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                          if (param) {
                            var match = param[0][0];
                            if (typeof match === "number" || match.tag !== /* V_tagged_raw */8) {
                              return invalid_args("union");
                            } else {
                              var match$1 = param[1];
                              if (match$1) {
                                var match$2 = match$1[0][0];
                                if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                  return invalid_args("union");
                                } else {
                                  return pack_set(Lang_value_set$BwaxMobile.union(match[1], match$2[1]));
                                }
                              } else {
                                return invalid_args("union");
                              }
                            }
                          } else {
                            return invalid_args("union");
                          }
                        }))
                ],
                /* :: */[
                  /* tuple */[
                    "intersect",
                    Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                            if (param) {
                              var match = param[0][0];
                              if (typeof match === "number" || match.tag !== /* V_tagged_raw */8) {
                                return invalid_args("intersect");
                              } else {
                                var match$1 = param[1];
                                if (match$1) {
                                  var match$2 = match$1[0][0];
                                  if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                    return invalid_args("intersect");
                                  } else {
                                    return pack_set(Lang_value_set$BwaxMobile.intersect(match[1], match$2[1]));
                                  }
                                } else {
                                  return invalid_args("intersect");
                                }
                              }
                            } else {
                              return invalid_args("intersect");
                            }
                          }))
                  ],
                  /* :: */[
                    /* tuple */[
                      "diff",
                      Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                              if (param) {
                                var match = param[0][0];
                                if (typeof match === "number" || match.tag !== /* V_tagged_raw */8) {
                                  return invalid_args("diff");
                                } else {
                                  var match$1 = param[1];
                                  if (match$1) {
                                    var match$2 = match$1[0][0];
                                    if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                      return invalid_args("diff");
                                    } else {
                                      return pack_set(Lang_value_set$BwaxMobile.diff(match[1], match$2[1]));
                                    }
                                  } else {
                                    return invalid_args("diff");
                                  }
                                }
                              } else {
                                return invalid_args("diff");
                              }
                            }))
                    ],
                    /* :: */[
                      /* tuple */[
                        "toList",
                        Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                if (param) {
                                  var match = param[0][0];
                                  if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                    return invalid_args("toList");
                                  } else {
                                    return Runtime_common$BwaxMobile.pack_list(Lang_value_set$BwaxMobile.to_list(match[1]));
                                  }
                                } else {
                                  return invalid_args("toList");
                                }
                              }))
                      ],
                      /* :: */[
                        /* tuple */[
                          "fromList",
                          Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                  if (param) {
                                    var match = param[0][0];
                                    if (typeof match === "number" || !(match.tag === /* V_list */1 && !param[1])) {
                                      return invalid_args("fromList");
                                    } else {
                                      return pack_set(Lang_value_set$BwaxMobile.from_list(match[0]));
                                    }
                                  } else {
                                    return invalid_args("fromList");
                                  }
                                }))
                        ],
                        /* :: */[
                          /* tuple */[
                            "foldl",
                            Runtime_common$BwaxMobile.pack_func(3, (function (param) {
                                    if (param) {
                                      var match = param[1];
                                      if (match) {
                                        var match$1 = match[1];
                                        if (match$1) {
                                          var match$2 = match$1[0][0];
                                          if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                            return invalid_args("foldl");
                                          } else {
                                            var f = param[0];
                                            var proc = function (acc, k) {
                                              return Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
                                                          acc,
                                                          /* :: */[
                                                            k,
                                                            /* [] */0
                                                          ]
                                                        ], Runtime_common$BwaxMobile.nt);
                                            };
                                            return Lang_value_set$BwaxMobile.foldl(proc, match[0], match$2[1]);
                                          }
                                        } else {
                                          return invalid_args("foldl");
                                        }
                                      } else {
                                        return invalid_args("foldl");
                                      }
                                    } else {
                                      return invalid_args("foldl");
                                    }
                                  }))
                          ],
                          /* :: */[
                            /* tuple */[
                              "map",
                              Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                      if (param) {
                                        var match = param[1];
                                        if (match) {
                                          var match$1 = match[0][0];
                                          if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                            return invalid_args("map");
                                          } else {
                                            var f = param[0];
                                            var proc = function (k) {
                                              return Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
                                                          k,
                                                          /* [] */0
                                                        ], Runtime_common$BwaxMobile.nt);
                                            };
                                            return pack_set(Lang_value_set$BwaxMobile.map(proc, match$1[1]));
                                          }
                                        } else {
                                          return invalid_args("map");
                                        }
                                      } else {
                                        return invalid_args("map");
                                      }
                                    }))
                            ],
                            /* :: */[
                              /* tuple */[
                                "filter",
                                Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                        if (param) {
                                          var match = param[1];
                                          if (match) {
                                            var match$1 = match[0][0];
                                            if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                              return invalid_args("filter");
                                            } else {
                                              var p = pack_predicate(param[0]);
                                              return pack_set(Lang_value_set$BwaxMobile.filter(p, match$1[1]));
                                            }
                                          } else {
                                            return invalid_args("filter");
                                          }
                                        } else {
                                          return invalid_args("filter");
                                        }
                                      }))
                              ],
                              /* :: */[
                                /* tuple */[
                                  "partition",
                                  Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                          if (param) {
                                            var match = param[1];
                                            if (match) {
                                              var match$1 = match[0][0];
                                              if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                return invalid_args("partition");
                                              } else {
                                                var p = pack_predicate(param[0]);
                                                var match$2 = Lang_value_set$BwaxMobile.partition(p, match$1[1]);
                                                return Runtime_common$BwaxMobile.pack_tuple(/* :: */[
                                                            pack_set(match$2[0]),
                                                            /* :: */[
                                                              pack_set(match$2[1]),
                                                              /* [] */0
                                                            ]
                                                          ]);
                                              }
                                            } else {
                                              return invalid_args("partition");
                                            }
                                          } else {
                                            return invalid_args("partition");
                                          }
                                        }))
                                ],
                                /* :: */[
                                  /* tuple */[
                                    "any",
                                    Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                            if (param) {
                                              var match = param[1];
                                              if (match) {
                                                var match$1 = match[0][0];
                                                if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                  return invalid_args("any");
                                                } else {
                                                  var predicate = pack_predicate(param[0]);
                                                  return Runtime_common$BwaxMobile.pack_bool(Lang_value_set$BwaxMobile.some(predicate, match$1[1]));
                                                }
                                              } else {
                                                return invalid_args("any");
                                              }
                                            } else {
                                              return invalid_args("any");
                                            }
                                          }))
                                  ],
                                  /* :: */[
                                    /* tuple */[
                                      "all",
                                      Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                              if (param) {
                                                var match = param[1];
                                                if (match) {
                                                  var match$1 = match[0][0];
                                                  if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                    return invalid_args("all");
                                                  } else {
                                                    var p = pack_predicate(param[0]);
                                                    return Runtime_common$BwaxMobile.pack_bool(Lang_value_set$BwaxMobile.every(p, match$1[1]));
                                                  }
                                                } else {
                                                  return invalid_args("all");
                                                }
                                              } else {
                                                return invalid_args("all");
                                              }
                                            }))
                                    ],
                                    /* :: */[
                                      /* tuple */[
                                        "minimum",
                                        Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                                if (param) {
                                                  var match = param[0][0];
                                                  if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                    return invalid_args("minimum");
                                                  } else {
                                                    var result = Lang_value_set$BwaxMobile.minimum(match[1]);
                                                    if (result !== undefined) {
                                                      return Runtime_common$BwaxMobile.pack_just(result);
                                                    } else {
                                                      return Runtime_common$BwaxMobile.pack_nothing;
                                                    }
                                                  }
                                                } else {
                                                  return invalid_args("minimum");
                                                }
                                              }))
                                      ],
                                      /* :: */[
                                        /* tuple */[
                                          "maximum",
                                          Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                                  if (param) {
                                                    var match = param[0][0];
                                                    if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                      return invalid_args("maximum");
                                                    } else {
                                                      var result = Lang_value_set$BwaxMobile.maximum(match[1]);
                                                      if (result !== undefined) {
                                                        return Runtime_common$BwaxMobile.pack_just(result);
                                                      } else {
                                                        return Runtime_common$BwaxMobile.pack_nothing;
                                                      }
                                                    }
                                                  } else {
                                                    return invalid_args("maximum");
                                                  }
                                                }))
                                        ],
                                        /* :: */[
                                          /* tuple */[
                                            "isEqual",
                                            Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                                    if (param) {
                                                      var match = param[0][0];
                                                      if (typeof match === "number" || match.tag !== /* V_tagged_raw */8) {
                                                        return invalid_args("isEqual");
                                                      } else {
                                                        var match$1 = param[1];
                                                        if (match$1) {
                                                          var match$2 = match$1[0][0];
                                                          if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                            return invalid_args("isEqual");
                                                          } else {
                                                            return Runtime_common$BwaxMobile.pack_bool(Lang_value_set$BwaxMobile.is_equal(match[1], match$2[1]));
                                                          }
                                                        } else {
                                                          return invalid_args("isEqual");
                                                        }
                                                      }
                                                    } else {
                                                      return invalid_args("isEqual");
                                                    }
                                                  }))
                                          ],
                                          /* [] */0
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var external_vals = /* :: */[
  external_vals_000,
  external_vals_001
];

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  external_vals
];

exports.module_name = module_name;
exports.src = src;
exports.invalid_args = invalid_args;
exports.pack_set = pack_set;
exports.pack_predicate = pack_predicate;
exports.external_vals = external_vals;
exports.externals = externals;
/* src Not a pure module */
